<template>
  <div class="app-wrapper">
    <div class="main-container">
      <div class="fixed-header">
        <nav-bar></nav-bar>
      </div>
      <app-main />
    </div>
    <footer-main />
  </div>
</template>

<script>
import AppMain from "./components/AppMain.vue";
import FooterMain from "./components/FooterMain.vue";
import NavBar from "./components/Navbar.vue";

export default {
  name: "Layout",
  components: {
    NavBar,
    AppMain,
    FooterMain
  },
  computed: {
    fixedHeader() {
      return true;
      // return this.$store.state.settings.fixedHeader
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "~@/styles/mixin.scss";
@import "~@/styles/variables.scss";

.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  &.mobile.openSidebar {
    position: fixed;
    top: 0;
  }
}
.main-container {
  padding-top: 60px;
  // height: 100vh;
}
.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: 100%;
  height: 60px;
  background-color: #fff;
  box-shadow: 0px 2px 10px 0px rgba(216, 216, 216, 0.7);
  // transition: width 0.28s;
}

.mobile .fixed-header {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/index.vue